export const shipmentTypes = [
  { value: 'ALL', label: 'All Types' },
  { value: 'MAN', label: 'Manual' },
  { value: 'RAT', label: 'Ratesheet' },
  { value: 'API', label: 'API' },
];

export const shipmentModes = [
  { value: 'ALL', label: 'All Modes' },
  { value: 'DIR', label: 'Direct' },
  { value: 'MMA', label: 'Multi Modal Air' },
  { value: 'MMS', label: 'Multi Modal Sea' },
  { value: 'INT', label: 'Interline' },
  { value: 'ATA', label: 'Air to Air' },
  { value: 'PTP', label: 'Port to Port' },
  { value: 'ANY', label: 'Any Order of Legs' },
  { value: 'CON', label: 'Consolidation' },
];

export const canceledOptions = [
  { id: 'all', value: 1, label: 'All' },
  { id: 'canceled', value: 2, label: 'Cancelled' },
  { id: 'uncanceled', value: 3, label: 'Uncancelled' },
];

export const deliveredOptions = [
  { id: 'all', value: 1, label: 'All' },
  { id: 'delivered', value: 2, label: 'Delivered' },
  { id: 'undelivered', value: 3, label: 'Undelivered' },
];

export const overdueOptions = [
  { id: 'all', value: 1, label: 'All' },
  { id: 'overdue', value: 2, label: 'Overdue' },
  { id: 'not_overdue', value: 3, label: 'Not Overdue' },
];

export const carrierTypes = [
  { value: 'ALL', label: 'All Types' },
  { value: 'AP', label: 'API' },
  { value: 'RS', label: 'Ratesheet' },
  { value: 'MC', label: 'Manual Carrier' },
];

export const carrierModes = [
  { value: 'ALL', label: 'All Modes' },
  { value: 'AI', label: 'Air' },
  { value: 'CO', label: 'Courier' },
  { value: 'LT', label: 'LTL' },
  { value: 'FT', label: 'FTL' },
  { value: 'SE', label: 'Sealift' },
];

export const jobSummaryProrities = [
  { value: '', label: 'All Priorities' },
  { value: 'LO', label: 'Low' },
  { value: 'ST', label: 'Standard' },
  { value: 'RU', label: 'Rush' },
  { value: 'CR', label: 'Critical' },
];

export const jobSummaryStatuses = [
  { value: '', label: 'All Status' },
  { value: 'CREATED', label: 'Created' },
  { value: 'STAGED', label: 'Staged' },
  { value: 'READY', label: 'Ready of Pickup' },
  { value: 'IN_TRANSIT', label: 'In Transit' },
  { value: 'COMPLETED', label: 'Completed' },
];

export const travelModes = [
  { value: '', label: 'All Modes' },
  { value: '0', label: 'Road Only' },
  { value: '1', label: 'Staged' },
  { value: '2', label: 'Flyable(Not Ideal)' },
  { value: '3', label: 'Flyable' },
  { value: '4', label: 'Sea/Barge' },
];

export const lmsItemStatuses = [
  { value: '', label: 'All Statues' },
  { value: 'On_Hand', label: 'On Hand' },
  { value: 'LOADED', label: 'Loaded' },
  { value: 'In_Transit', label: 'In Transit' },
  { value: 'Final_Destination', label: 'Final Destination' },
  { value: 'DELIVERED', label: 'Delivered' },
  { value: 'Deconsolidated', label: 'Deconsolidated' },
];

export const lmsFileTypes = [
  { id: 'pdf', value: 1, label: 'PDF' },
  { id: 'excel', value: 2, label: 'Excel' },
];

export const shippingModuleReports = [
  {
    title: 'Shipment Overview Report',
    description:
      'This report contains information from main shipment information, routing, references.',
    type: 'SHIPMENT_OVERVIEW',
  },
  {
    title: 'Leg Overview Report',
    description: 'This report contains information related to legs.',
    type: 'LEG_OVERVIEW',
  },
  {
    title: 'Tracking Report',
    description: 'The report contains tracking information for shipments.',
    type: 'LEG_TRACKING',
  },
  {
    title: 'Jobs Overview Report',
    description: 'This report contains information related to jobs.',
    type: 'JOB_OVERVIEW',
  },
  {
    title: 'Jobs Summary Report',
    description: 'This report contains information related to Job Summary.',
    type: 'JOB_SUMMARY',
  },
];

export const lmsModuleReports = [
  {
    title: 'LMS: On Hand Report',
    description:
      'Provides a current inventory snapshot of all items available in the warehouse.',
    type: 'LMS_ON_HANDS',
  },
  {
    title: 'LMS: Aircraft Load By Type Report',
    description:
      'Shows the distribution of cargo loads by aircraft type within the warehouse.',
    type: 'LMS_LOAD_BY_TYPE',
  },
  {
    title: 'LMS: Aircraft Load By Date Report',
    description:
      'Details the cargo loads processed by aircraft, organized by date.',
    type: 'LMS_LOAD_BY_DATE',
  },
  {
    title: 'LMS: Aircraft Load Summary',
    description:
      'Summarizes the total cargo loads handled, categorized by aircraft type and date.',
    type: 'LMS_LOAD_SUMMARY',
  },
  {
    title: 'LMS: Receive By Type Report',
    description:
      'Summaries the total fright types for items that have been received.',
    type: 'LMS_RECEIVED_SUMMARY',
  },
];

export const reports = [...shippingModuleReports, ...lmsModuleReports] as const;

export const reportsAdmin = [
  ...reports,
  {
    title: 'Account Report',
    description: 'The report contains all information regarding accounts.',
    type: 'ACCOUNT',
  },

  {
    title: 'Quote History Report',
    description:
      "The report contains all previous carrier quotes returned. It will contain information regarding each carrier pricing for a quote request and will be grouped together by coloumn 'id' and sorted cheapest to most expensive.",
    type: 'QUOTE_HISTORY',
  },

  {
    title: 'Quote History by Leg',
    description:
      "The report contains all previous LTL carrier quotes returned. It will contain information regarding each LTL carrier pricing for a quote request and will be grouped together by coloumn 'id' and sorted cheapest to most expensive.",
    type: 'QUOTE_HISTORY_LEG',
  },
] as const;

export const shippingModuleReportTypes = [
  'SHIPMENT_OVERVIEW',
  'LEG_OVERVIEW',
  'LEG_TRACKING',
  'JOB_OVERVIEW',
  'JOB_SUMMARY',
  'ACCOUNT',
  'QUOTE_HISTORY',
  'QUOTE_HISTORY_LEG',
];

export const lmsModuleReportTypes = [
  'LMS_ON_HANDS',
  'LMS_LOAD_BY_TYPE',
  'LMS_LOAD_BY_DATE',
  'LMS_LOAD_SUMMARY',
  'LMS_RECEIVED_SUMMARY',
];
